import { render } from "./InitialCapitalPie.vue?vue&type=template&id=57e4a914"
import script from "./InitialCapitalPie.vue?vue&type=script&lang=js"
export * from "./InitialCapitalPie.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/zinzeszinsapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__